module.exports = __webpack_public_path__ + "img/Weapon_181.9bec414f.png";